/**
 * Arrival reviews, inside Manifest Review (2026-10-14).
 *
 * Ruling, Isaiah Cotto, 2026-10-13 ("CounselEar arrival review"): the manifest
 * reviewer rules on CounselEAR arrival reviews ONLY -- the reviews the
 * CounselEAR create opens when it cannot tell whether an arriving CounselEAR
 * resident is someone eMerge already holds. Her workspace is Manifest Review, not
 * the Patient Advocate workspace (she holds no ADVOCACY_LEAD_VIEW), so the desk
 * lives here, next to "No building" (Copilot review of #402, 4266772279).
 *
 * The same endpoints and the same card the PA manager uses (residentsApi,
 * IdentityReviews). The server scopes what she sees: CounselEAR arrival reviews
 * only, no SSN-derived field. PA managers keep their place in the Patient
 * Advocate workspace and see the full card here too.
 */
import React from 'react';
import { IdentityReviews } from '../advocate/ResidentsView';
import type { IdentityScope } from '../advocate/residentsApi';
import { StateBlock as TideState } from '../../components/tide';
import '../advocate/advocate.css';

/** Who may rule here, from GET /residents: the broad review, or the CounselEAR-arrival review. */
export const reviewsArrivals = (s: IdentityScope | null): boolean => Boolean(s && s.held && (s.held.review || s.held.review_counselear_arrival));

export default function ArrivalReviewsDesk({ identity }: { identity: IdentityScope | null }) {
  if (!reviewsArrivals(identity)) {
    return (
      <main className="mf-main mf-main--board">
        <TideState kind="empty" reason="none" kindLabel="Not your list" message="Arrival reviews are ruled by the manifest reviewer and the Patient Advocate managers." />
      </main>
    );
  }
  return (
    <main className="mf-main mf-main--board">
      <div className="pa-residents mf-arrivals">
        <IdentityReviews arrivalOnly={!(identity as IdentityScope).held.review} canRule={Boolean((identity as IdentityScope).can && ((identity as IdentityScope).can.review || (identity as IdentityScope).can.review_counselear_arrival))}
          canNameResident={!(identity as IdentityScope).held.review || Boolean((identity as IdentityScope).held.set_counselear_id)} />
      </div>
    </main>
  );
}
